import * as actionTypes from './actionsTypes';

export function getHolderAbsenceReport(params) {
  /**
   * @param clientId
   * @param day
   */
  return {
    type: actionTypes.HOLDER_ABSENCE_REPORT_GET,
    payload: {
      params,
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/actions/holderAbsenceReport.js